export enum IntegrationStatus {
  TEST_PENDING = 'Test Pending',
  TEST_IN_PROGRESS = 'Testing in Progress',
  TEST_SUCCESS = 'Tested - Success',
  TEST_FAILED = 'Tested - Failed',
  PUBLISHED = 'Published',
  ERROR = 'Error',
  DELETED = 'Deleted',
}
